module.exports = __webpack_public_path__ + "static/media/Source Info.c8caf0b6.txt";